import React from "react";

function PersonRow({ person }) {
  const fullName = [person.firstName, person.lastName, person.suffix]
    .filter(Boolean)
    .join(" ");

  const years = [];
  if (person.birthYear) years.push(person.birthYear);
  if (person.deathYear) years.push(person.deathYear);

  const yearStr =
    years.length === 2
      ? `(${years[0]}\u2013${years[1]})`
      : years.length === 1
        ? person.deathYear
          ? `(d. ${years[0]})`
          : `(b. ${years[0]})`
        : "";

  return (
    <div className="flex items-center gap-x-[8px] py-[4px] px-[8px] text-sm text-dupontBlue dark:text-darkText">
      <span className="font-medium">{fullName}</span>
      {yearStr && <span className="text-dupontGray dark:text-darkTextSecondary text-[13px]">{yearStr}</span>}
    </div>
  );
}

export default PersonRow;
